export const RESTAURANT_MENU_LINK_MENU_ITEM_APPEARANCE = {
    availableForOrder: true,
    allowSpecialRequests: true,
    maxAmount: null,
};
export const getRestaurantMenuLinkPlateItemsWithAppearance = (plateItems) => {
    return plateItems.map(plateItem => {
        return {
            ...plateItem,
            menuItemAppearance: RESTAURANT_MENU_LINK_MENU_ITEM_APPEARANCE,
        };
    });
};
//# sourceMappingURL=utils.js.map